export default "__VITE_ASSET__66551beb__"